"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderWrapper = void 0;
const material_1 = require("@mui/material");
exports.LoaderWrapper = (0, material_1.styled)("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    "> div": {
        marginTop: "12px"
    }
});
